import Decimal from 'decimal.js'

import { invoiceStates } from '@/modules/base/util/constants'

const { LOCKED, PAID, PARTIALLYPAID } = invoiceStates

const getStateAndOutstandingAmount = (newBookings, totalGross) => {
  const outstandingAmount = newBookings.reduce((outstandingAmount, booking) => {
    const { assignments } = booking
    const amount = assignments.reduce((amount, assignment) => {
      return new Decimal(amount).plus(assignment.amount).toDP(2).toNumber()
    }, 0)

    return new Decimal(outstandingAmount).minus(Math.abs(amount)).toDP(2).toNumber()
  }, totalGross)

  let state = LOCKED
  if (outstandingAmount > 0 && outstandingAmount < totalGross) {
    state = PARTIALLYPAID
  } else if (outstandingAmount <= 0) {
    state = PAID
  } else {
    state = LOCKED
  }

  return { outstandingAmount, state }
}

export default getStateAndOutstandingAmount
